import React from 'react';
import { SUMMER_PROGRAM_TEMPLATES } from './templates';

const templateIcons = {
  whyThisProgram: '🎯',
  goalsAndInterests: '🌟',
  personalStatement: '📝',
  researchInterest: '🔬',
  challengeGrowth: '💪',
  genericShortAnswer: '✏️'
};

const TemplatePicker = ({ onSelectTemplate, suggestedTemplateId = null }) => {
  return (
    <div className="p-6">
      <h2 className="text-xl font-bold text-slate-900 mb-2">Choose a Writing Template</h2>
      <p className="text-sm text-stone-600 mb-6">
        Each template guides you through writing sections that build into a complete response.
      </p>

      {suggestedTemplateId && (
        <div className="bg-violet-50 border border-violet-200 rounded-lg p-3 mb-4">
          <p className="text-sm text-violet-700">
            <span className="font-semibold">Suggested:</span>{' '}
            Based on your prompt, we recommend the{' '}
            <button
              onClick={() => onSelectTemplate(suggestedTemplateId)}
              className="font-semibold underline hover:text-violet-900"
            >
              {SUMMER_PROGRAM_TEMPLATES.find(t => t.id === suggestedTemplateId)?.title}
            </button>{' '}
            template.
          </p>
        </div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
        {SUMMER_PROGRAM_TEMPLATES.map((template) => (
          <button
            key={template.id}
            onClick={() => onSelectTemplate(template.id)}
            className={`p-4 rounded-xl border-2 text-left transition-all hover:shadow-md ${
              template.id === suggestedTemplateId
                ? 'border-violet-300 bg-violet-50'
                : 'border-stone-200 bg-white hover:border-violet-200'
            }`}
          >
            <div className="flex items-center gap-2 mb-2">
              <span className="text-xl">{templateIcons[template.id] || '📄'}</span>
              <h3 className="font-semibold text-slate-900">{template.title}</h3>
            </div>
            <p className="text-sm text-stone-600 mb-2">{template.description}</p>
            <div className="flex items-center gap-3 text-xs text-stone-500">
              <span>{template.sections.length} sections</span>
              <span>~{template.wordTarget} words</span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default TemplatePicker;
